/* import __COLOCATED_TEMPLATE__ from './hcp-eu-private-beta-modal.hbs'; */
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { action } from '@ember/object';

// We are required to display the EU private beta modal until the product is generally available.
// This modal will be retired once the product is GA post October 1st, 2025 as part of
// https://hashicorp.atlassian.net/browse/HCPIE-2833
export default class HcpEuPrivateBetaModal extends Component {
  @service privateBeta;

  get showModal() {
    return this.privateBeta.showModal;
  }

  @action
  close() {
    this.privateBeta.hideModal();
  }
}
